@if (data?.modalTitle) {
  <h5 mat-dialog-title>{{ data?.modalTitle }}</h5>
}
<mat-dialog-content>
  <div [innerHTML]="content"></div>
</mat-dialog-content>
<mat-dialog-actions>
  @if (cancel) {
    <button mat-button [mat-dialog-close]="false">{{cancel}}</button>
  }
  <button mat-raised-button color="primary" [mat-dialog-close]="true">{{confirm}}</button>
</mat-dialog-actions>
